import Vue from "vue";
import "babel-polyfill";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./main.sass";
import i18n from "./i18n";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSocketIO from "vue-socket.io";
import Toasted from "vue-toasted";
import { DatetimePicker } from "vant";

Vue.config.productionTip = false;
Vue.prototype.$reachDishLimitPrice = (data) => {
  console.log(store.state.carts);
  let carts = store.state.carts;
  let count = carts.filter(it => it.guid === data.guid).reduce((pre, cur) => {
    return pre + Number(cur.num);
  }, 0);
  count++;
  if (!data.commodityPricing || !Number(data.commodityPricing.price_threshold)) {
    return false;
  } else {
    let limit = Number(data.commodityPricing.price_threshold) - 1;
    return count > limit;
  }
};
Vue.prototype.$allowAddAttr = (attributesCate, selected, guid, _cateItem) => {
  let cateItem = null;
  attributesCate.forEach(cate => {
    if (cate.attributes && cate.attributes.length) {
      cate.attributes.forEach(it => {
        if (it.guid === guid) {
          cateItem = cate;
        }
      });
    }
  });
  if (guid && !cateItem) return false;
  if (!cateItem) cateItem = _cateItem;
  let cateSelectNum = 0;
  attributesCate.forEach(cate => {
    if (cate.attributes && cate.attributes.length) {
      if (cate.guid === cateItem.guid) {
        cate.attributes.forEach(it => {
          if (selected.includes(it.guid)) {
            cateSelectNum++;
          }
        });
      }
    }
  });
  if (Number(cateItem.min_limit) && guid && cateItem.type === 1 && (cateSelectNum >= Number(cateItem.min_limit))) {
    alert(cateItem.attr_cate_name + i18n.t("unClass.add390", { num: cateItem.min_limit }));
    return false;
  }
  if (Number(cateItem.min_limit) && !guid && cateItem.type === 0 && (cateSelectNum < Number(cateItem.min_limit))) {
    alert(cateItem.attr_cate_name + i18n.t("unClass.add389", { num: cateItem.min_limit }));
    return false;
  }
  if (Number(cateItem.min_limit) && !guid && cateItem.type === 1 && (cateSelectNum !== Number(cateItem.min_limit))) {
    alert(cateItem.attr_cate_name + i18n.t("unClass.add392", { num: cateItem.min_limit }));
    return false;
  }
  return true;
};
Vue.use(DatetimePicker);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDXywVbCLffjc6y3PCdGAKS1DJ-qF-RllE",
    libraries: "places",
    region: "ES",
    language: "es"
    // v: "3.26"
  }
  // Demonstrating how we can customize the name of the components
  // installComponents: false
});

Vue.use(
    new VueSocketIO({
      debug: true,
      connection: process.env.VUE_APP_SOCKET_URL,
      vuex: {
        store,
        actionPrefix: "SOCKET_",
        mutationPrefix: "SOCKET_"
      },
      options: { path: "" } //Optional options
    })
);

Vue.use(Toasted, {
  position: "top-center",
  className: "custom-toasted",
  duration: 2000
});

import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";

SwiperClass.use([Pagination, Mousewheel, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
import "swiper/swiper-bundle.css";

import GSignInButton from "vue-google-signin-button";

Vue.use(GSignInButton);

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
